
import { createBrowserRouter } from "react-router-dom";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import Settings from "@/pages/Settings";
import Chatbot from "@/pages/Chatbot";
import TelegramChat from "@/pages/TelegramChat";
import Campaigns from "@/pages/Campaigns";
import QuickMessages from "@/pages/QuickMessages";
import AIAgents from "@/pages/AIAgents";
import Users from "@/pages/Users";
import Integrations from "@/pages/Integrations";
import AvatarSelection from "@/pages/AvatarSelection";
import Contacts from "@/pages/Contacts";
import Monitoring from "@/pages/Monitoring";
import AutomationFlowPage from "@/pages/AutomationFlow";
import Layout from "@/components/Layout";
import { Navigate } from "react-router-dom";
import AuthGuard from "@/components/auth/AuthGuard";

const protectedRoutes = [
  {
    path: "/",
    element: <AuthGuard><Layout><Index /></Layout></AuthGuard>,
  },
  {
    path: "/contacts",
    element: <AuthGuard><Layout><Contacts /></Layout></AuthGuard>,
  },
  {
    path: "/settings",
    element: <AuthGuard><Layout><Settings /></Layout></AuthGuard>,
  },
  {
    path: "/monitoring",
    element: <AuthGuard><Layout><Monitoring /></Layout></AuthGuard>,
  },
  {
    path: "/chatbot",
    element: <AuthGuard><Layout><Chatbot /></Layout></AuthGuard>,
  },
  {
    path: "/telegram",
    element: <AuthGuard><Layout><TelegramChat /></Layout></AuthGuard>,
  },
  {
    path: "/campaigns",
    element: <AuthGuard><Layout><Campaigns /></Layout></AuthGuard>,
  },
  {
    path: "/quick-messages",
    element: <AuthGuard><Layout><QuickMessages /></Layout></AuthGuard>,
  },
  {
    path: "/ai-agents",
    element: <AuthGuard><Layout><AIAgents /></Layout></AuthGuard>,
  },
  {
    path: "/users",
    element: <AuthGuard><Layout><Users /></Layout></AuthGuard>,
  },
  {
    path: "/integrations",
    element: <AuthGuard><Layout><Integrations /></Layout></AuthGuard>,
  },
  {
    path: "/automation-flow",
    element: <AuthGuard><Layout><AutomationFlowPage /></Layout></AuthGuard>,
  },
  {
    path: "/avatar-selection",
    element: <AuthGuard><Layout><AvatarSelection /></Layout></AuthGuard>,
  },
];

const publicRoutes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  }
];

export const router = createBrowserRouter([
  ...publicRoutes,
  ...protectedRoutes
]);
